<template>
  <div
    :class="{ 'container': useContainer, 'redirect-block-select': blockParams?.isUrl }"
    @click="$emit('block:redirect')"
  >
    <div
      class="center"
      :style="{
        'padding-top': paddingTop + 'px',
        'padding-bottom': paddingBottom + 'px'
      }"
    >
      <a
        v-if="mainFields?.link?.value?.startsWith(['https://'])"
        :href="mainFields?.link?.value"
        target="_blank"
        class="btn btn--long btn--full"
      >
        {{ mainFields.title.value }}
      </a>
      <nuxt-link
        v-else
        :to="{ path: mainFields?.link?.value?.[0] === '/' ? mainFields?.link?.value : `/${mainFields?.link?.value}` }"
        class="btn btn--long btn--full"
      >
        {{ mainFields.title.value }}
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default {
  mixins: [staticBlockMixin]
}
</script>

<style>

</style>
